import React from 'react';
import './mygoals.css';
import { FaCheck } from 'react-icons/fa';
import homeContent from '../../../content/pages/home.json';

const MyGoals = () => {
    const { heading, subheading, goals, footer } = homeContent.myGoals;

    return (
        <section className='our-goals-container'>
            <h2>{heading}</h2>
            <h3>{subheading}</h3>
            <ul>
                {goals.map((goal, index) => (
                    <li key={index}><FaCheck className="checkmark" /> {goal}</li>
                ))}
            </ul>
            <p>{footer}</p>
        </section>
    );
}

export default MyGoals;
